import { CInputText, CInputPassword , CToggle , CMultiSelect , CSelect , CInputTextArea} from "./CInput";
import { CommaFire } from "./CommaFire";
import {Base} from './layout/Base'
import { ReportSelectPeriod } from "./Report-Component";
import { TablePage , TablePagination } from "./CTable";
import { FakeData } from "./FakeData";
import { BtnLoader , PageLoader , PageLoaderOpacity , SearchSpinner} from "./Loasder";
import { CSkeletonTable , CSkeletonDashboard , CSkeletonPlan , CSkeletonNavList} from "./CSkeleton";
import { toast } from "react-toastify";
import { CModal , ModalDelete , ModalFilterUser } from "./CModal";
import { MapCont } from "./map";
import { StatusChart , ActiveUserChart } from "./Dashboard-Component";
import { CheckPermission } from "./checkPermission";

export {
    CInputText,
    CommaFire,
    CInputPassword,
    CToggle ,
    CInputTextArea ,
    CMultiSelect ,
    CSelect,
    ReportSelectPeriod ,
    TablePage ,
    TablePagination ,
    FakeData ,
    BtnLoader ,
    PageLoader,
    PageLoaderOpacity,
    CSkeletonTable ,
    CSkeletonDashboard ,
    CSkeletonPlan,
    CSkeletonNavList,
    toast ,
    CModal ,
    ModalDelete,
    ModalFilterUser ,
    SearchSpinner ,
    MapCont,
    StatusChart,
    ActiveUserChart ,
    CheckPermission ,
    Base
};